import { createRootRoute, Outlet } from "@tanstack/react-router";
import { Toaster } from "sonner";
import { useAuthListener, useAuthStore } from "@/features/auth";
import { useEffect } from "react";
import { Spinner } from "@/components/ui/spinner";

export const Route = createRootRoute({
  component: RootComponent,
})

function RootComponent() {
  const initialize = useAuthStore((s) => s.initialize);
  const isInitialized = useAuthStore((s) => s.isInitialized);

  useAuthListener();

  useEffect(() => {
    initialize();
  }, [initialize]);

  if (!isInitialized) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Spinner />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Outlet />
      <Toaster />
    </>
  )
}